


import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class LoadingAnimationComponent extends Vue {
	@Prop(String)
	private text!: string;
}
